import PropTypes from 'prop-types';
import React from 'react';

import Col from './components/Col';
import Row from './components/Row';

export const FlexBoxRow = props => <Row data-test='row' {...props}/>;
export const FlexBoxCol = props => <Col data-test='col' {...props}/>;

const ResponsiveName = ['xs', 'sm', 'md', 'lg'];

const ResponsiveType = PropTypes.oneOf(ResponsiveName);
FlexBoxRow.propTypes = {
    reverse: PropTypes.bool,
    start: ResponsiveType,
    center: ResponsiveType,
    end: ResponsiveType,
    top: ResponsiveType,
    middle: ResponsiveType,
    bottom: ResponsiveType,
    around: ResponsiveType,
    between: ResponsiveType,
    first: ResponsiveType,
    last: ResponsiveType,
    children: PropTypes.node,
};

const DimensionPropTypes = ResponsiveName.reduce((propTypes, dimension) => {
    propTypes[dimension] = PropTypes.oneOfType([PropTypes.number, PropTypes.bool]);
    propTypes[dimension + 'Offset'] = PropTypes.number;
    return propTypes;
}, {});

FlexBoxCol.propTypes = {
    ...DimensionPropTypes,
    reverse: PropTypes.bool,
    children: PropTypes.node,
};
